import React from 'react';
import { generatePlacementInterpretation } from '../../lib/placementInterpretation';
import { formatPlacementLabel } from '../../lib/chartFormat';
import { formatPlacementWithGlyph, getPlanetGlyph, getSignGlyph } from '../../lib/chartGlyphs';
import { ordinalHouse } from '../../lib/reportUtils';

function PlacementInterpretationPanel({ placement, chart }) {
  if (!placement || !chart) return null;
  const interpretation = generatePlacementInterpretation({ placement });
  if (!interpretation) return null;

  return (
    <div className="chart-accordion-panel" role="status" aria-live="polite">
      <p className="chart-accordion-panel-label">Selected placement</p>
      <h4 className="chart-accordion-panel-title">{formatPlacementWithGlyph(placement, ordinalHouse)}</h4>
      <h5 className="chart-accordion-panel-sub">Core pattern</h5>
      <p className="chart-accordion-panel-body">{interpretation.corePattern}</p>
      <h5 className="chart-accordion-panel-sub">Possible expressions</h5>
      <ul className="chart-accordion-panel-list">
        {interpretation.possibleExpressions.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <h5 className="chart-accordion-panel-sub">Observation</h5>
      <p className="chart-accordion-panel-body">{interpretation.observation}</p>
    </div>
  );
}

const PlacementsTable = ({ placements, selectedKey, onSelect, chart }) => {
  const handleRowClick = (planetKey) => {
    onSelect(planetKey === selectedKey ? null : planetKey);
  };

  return (
    <div className="chart-table-wrap card">
      <h3>Planetary positions</h3>
      <p className="chart-interaction-hint">Select a row to expand the interpretation directly below it.</p>
      <table className="chart-table">
        <thead>
          <tr>
            <th>Body</th>
            <th>Sign</th>
            <th>Degree</th>
            <th>House</th>
            <th>Retrograde</th>
          </tr>
        </thead>
        <tbody>
          {placements.map((placement) => (
            <React.Fragment key={placement.key}>
              <tr
                className={placement.key === selectedKey ? 'chart-row-selected' : ''}
                onClick={() => handleRowClick(placement.key)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleRowClick(placement.key);
                  }
                }}
              >
                <td><span className="chart-aspect-glyph">{getPlanetGlyph(placement.key)}</span> {placement.body}</td>
                <td><span className="chart-aspect-glyph">{getSignGlyph(placement.sign)}</span> {placement.sign}</td>
                <td>{placement.degreeText}</td>
                <td>{placement.house ?? '—'}</td>
                <td>{placement.retrograde ? 'Yes' : 'No'}</td>
              </tr>
              {placement.key === selectedKey && chart && (
                <tr className="chart-accordion-row">
                  <td colSpan={5} className="chart-accordion-cell">
                    <PlacementInterpretationPanel
                      placement={chart.planets?.find((p) => p.key === placement.key) || { ...placement, name: placement.body }}
                      chart={chart}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlacementsTable;
